<template>
    <q-page class="q-pa-md">

        <q-dialog class="rounded-borders" v-model="dialogNuevoLocalizador" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Localizador</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">

                    <div class="col-12">
                        <q-field dense outlined label="Cliente" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{ selectCotizacion.rfc_cliente + ' '
                                        + selectCotizacion.razon_social_cliente }}</div>
                            </template>
                        </q-field>
                    </div>

                    <div class="col-12">
                        <q-field dense outlined label="Vehículo" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{ `Marca: ${autoContrato.marca}, Modelo: ${autoContrato.modelo}, Tipo de Vehiculo:
                                    ${autoContrato.tipovehiculo}, Color: ${autoContrato.color}, Año:
                                    ${autoContrato.anio}, Permiso: ${autoContrato.permiso}, Placa:
                                    ${autoContrato.placa}, ${autoContrato.estadoplaca}, ${autoContrato.numeroserie}` }}

                                </div>
                            </template>
                        </q-field>
                    </div>

                    <div class="col-12 col-md-12">
                        <q-select dense outlined v-model="selectAgenciaLocalizador" :options="listaAgenciasLocalizador"
                            label="Proveedor" color="primary" option-label="razon_social" clearable
                            options-selected-class="text-deep-blue">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                        <q-item-label caption>{{ scope.opt.representante
                                            }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fecha_compra_l" label="Fecha de Compra"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fecha_compra_l">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fecha_instalacion_l"
                            label="Fecha de Instalación" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fecha_instalacion_l">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="costo_adquisicion_l" outlined label="Costo de Adquisición"
                            required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="costo_mensual_l" outlined label="Costo Mensual" required
                            mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="numero_serie_l" outlined label="Número de Serie" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="marca_l" outlined label="Marca" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="modelo_l" outlined label="Modelo" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="tipo_l" outlined label="Tipo" required />
                    </div>

                </q-card-section>

                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat color="primary" label="Asignar Localizador" @click="PostLocalizador()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogNuevoAuto" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles del Vehiculo</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-separator class="q-mt-md" />
                <q-card-section>
                    <!-- INFORMACION DEL CLIENTE Y DE SUS DOCUMENTOS -->
                    <q-card class="shadow-0">
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12 col-md-12">
                                    <q-select dense outlined v-model="selectAgencia" :options="listaAgencias"
                                        label="Agencia" color="primary" option-label="razon_social" clearable
                                        options-selected-class="text-deep-blue">
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-car" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                                    <q-item-label caption>{{ scope.opt.representante
                                                    }}</q-item-label>
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>

                                <div class="col-12 col-md-12">
                                    <q-select outlined v-model="selectModelo" :options="itemsModelos"
                                        label="Modelo del Vehiculo" option-label="modelo" dense required emit-value
                                        map-options>
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-car" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.marca + ' ' + scope.opt.modelo + ' ' + scope.opt.version" />
                                                    <q-item-label caption>{{ scope.opt.tipovehiculo + ', ' +
                                                        scope.opt.anio + ', ' + scope.opt.color
                                                    }}</q-item-label>
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.marca" outlined label="Nombre de marca" dense
                                        required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.modelo" outlined label="Modelo" dense required
                                        readonly />
                                </div>

                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.version" outlined label="Version" dense required
                                        readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.tipovehiculo" outlined label="Tipo de Vehiculo" dense
                                        required readonly />
                                </div>
                                <!-- <div class="col-12 col-md-4">
                                            <q-input outlined label="Precio" dense required />
                                        </div> -->
                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.anio" outlined label="Año" dense required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="selectModelo.color" outlined label="Color" dense required
                                        readonly />
                                </div>
                            </div>
                        </q-card-section>
                        <q-separator class="q-mt-md" />
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12 col-md-3">
                                    <q-input v-model="auto.numeroserie" outlined label="Número de Serie" dense
                                        required />
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-input v-model="auto.numeromotor" outlined label="Número de Motor" dense
                                        required />
                                </div>

                                <div class="col-12 col-md-3">
                                    <q-input v-model="auto.placa" outlined label="Placa" dense required />
                                </div>

                                <div class="col-12 col-md-3">
                                    <q-input v-model="auto.permiso" outlined label="Núm. Permiso" dense required />
                                </div>

                                <div class="col-12 col-md-6">
                                    <q-input v-model="auto.estadoplaca" outlined label="Estado (Origen)" dense
                                        required />
                                </div>
                                <div class="col-12 col-md-6">
                                    <q-input class="q-ma-none q-pa-none" dense outlined v-model="auto.fechaadquisicion"
                                        label="Fecha de Adquisición" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:after>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                    transition-show="scale" transition-hide="scale">
                                                    <q-date class="q-ma-none q-pa-none" v-model="auto.fechaadquisicion">
                                                        <div class="row items-center justify-end q-ma-none q-pa-none">
                                                            <q-btn v-close-popup label="Ok" color="primary"
                                                                class="q-ma-none q-pa-none" flat />
                                                        </div>
                                                    </q-date>
                                                </q-popup-proxy>
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-input v-model="auto.beneficionproveedor" outlined label="Notas" dense required />
                                </div>
                            </div>
                        </q-card-section>
                        <q-card-actions>
                            <q-btn flat color="red" label="Cerrar" v-close-popup />
                            <q-space />
                            <q-btn @click="PostAuto()" flat color="primary" label="Guardar" />
                        </q-card-actions>
                    </q-card>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogNuevoSeguro" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Seguro</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">

                    <div class="col-12">
                        <q-field dense outlined label="Cliente" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{ selectCotizacion.rfc_cliente + ' '
                                        + selectCotizacion.razon_social_cliente }}</div>
                            </template>
                        </q-field>
                    </div>
                    <div class="col-12">
                        <q-field dense outlined label="Vehículo" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{ `Marca: ${autoContrato.marca}, Modelo: ${autoContrato.modelo}, Tipo de Vehiculo:
                                    ${autoContrato.tipovehiculo}, Color: ${autoContrato.color}, Año:
                                    ${autoContrato.anio}, Permiso: ${autoContrato.permiso}, Placa:
                                    ${autoContrato.placa}, ${autoContrato.estadoplaca}, ${autoContrato.numeroserie}` }}

                                </div>
                            </template>
                        </q-field>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-select dense outlined v-model="selectAgenciaSeguro" :options="listaAgenciasSeguro"
                            label="Proveedor" color="primary" option-label="razon_social" clearable
                            options-selected-class="text-deep-blue">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                        <q-item-label caption>{{ scope.opt.representante
                                            }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>

                    <div class="col-12">
                        <div class="text-subtitle2">Datos de la Poliza de Seguro </div>
                        <q-separator />
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fechaemision" label="Fecha de Emisión"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaemision">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="finicio" label="Vigencia Inicial" mask="date"
                            bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="finicio">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fvencimiento" label="Vigencia Final"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fvencimiento">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="flimitepago" label="Fecha limite de Pago"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="flimitepago">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-8">
                        <q-input dense v-model="tipo" outlined label="Tipo de Seguro" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="poliza" outlined label="Póliza" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="endoso" outlined label="Posible Endoso" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-select outlined v-model="formapago" :options="['Anual']" label="Forma de Pago" dense
                            required>
                        </q-select>
                    </div>
                    <!-- <div class="col-12 col-md-4">
                        <q-input prefix="$" readonly dense v-model="costototal" outlined label="Costo Total" required
                            mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div> -->
                    <div class="col-12 col-md-4">
                        <q-field dense outlined label="Costo Total" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline text-right" tabindex="0">
                                    {{ formatoMonedaMexicana(costototal) }}</div>
                            </template>
                        </q-field>
                    </div>

                    <div class="col-12 col-md-4">
                        <q-input dense v-model="agentedemisiones" outlined label="Agente de Emisiones" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="numerotelsiniestro" outlined label="Número Teléfonico para Siniestros"
                            required mask="(###) ### - ####" />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="oficinaregional" outlined label="Oficina Regional" required />
                    </div>
                    <div class="col-12 col-md-12">
                        <q-file v-model="archivoSeleccionado" dense outlined label="Subir Documento PDF de la Póliza"
                            class="full-width" accept=".pdf,application/pdf">
                        </q-file>
                    </div>

                    <div class="col-12 col-md-12">
                        <q-input dense v-model="notas" outlined label="Notas" required />
                    </div>

                    <div class="col-12">
                        <div class="text-subtitle2">Datos de la cuenta por Cobrar </div>
                        <q-separator />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-select outlined v-model="formacobro" :options="['Anual']" label="Forma de Cobro" dense
                            required>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="pagoperiodo" outlined label="Total a pagar por periodo"
                            required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="flimitecobro"
                            label="Fecha limite de Cobro al cliente" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="flimitecobro">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="pagoinicial" outlined label="Pago Inicial" required
                            mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>

                </q-card-section>
                <div class="q-ma-md doc-note">
                    <p class="doc-note__title">Aviso</p>
                    <p class=""> Al crear la cuenta por pagar, asi mismo se le creara una cuanta por cobrar al
                        cliente.</p>
                </div>
                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat color="primary" label="Crear Seguro" @click="PostSeguro()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVisualizadorOP" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="  q-pb-none">
                    <div class="row">
                        <div class="col-2">
                            <div class="text-h6">Vista previa PDF</div>
                        </div>
                        <div class="col-8 text-center">
                            <q-btn-group push>
                                <q-btn push label="Desacargar" color="primary" icon="download"
                                    @click="descargarPDFOP()" />
                                <q-btn push label="Enviar WhatsApp" color="primary" icon="mdi-whatsapp"
                                    @click="notificarCuentaCobrar()" />
                                <q-btn push label="Enviar Correo" color="primary" icon="email" />
                            </q-btn-group>
                        </div>
                        <div class="col-2 text-right">
                            <q-btn icon="close" flat round dense v-close-popup />
                        </div>
                    </div>
                </q-card-section>
                <q-card-section>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>


        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="selectCotizacion != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas la creación de una cuenta por cobrar al cliente
                                <strong>{{ selectCotizacion.rfc_cliente + " " + selectCotizacion.razon_social_cliente
                                    }}</strong>, por un pago inicial de
                                <strong>{{ formatoMonedaMexicana(selectCotizacion.pagoinicialtotal) }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al confirmar, se le notificara al usuario que tiene una cuenta pendiente por pagar,
                            para proceder con el contrato.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="PostCxC()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogConfirmarContrato" persistent>
            <q-card v-if="selectCotizacion != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirma la creación de un nuevo contrato para el cliente
                                <strong>{{
                                    selectCotizacion.rfc_cliente + " " + selectCotizacion.razon_social_cliente
                                    }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al confirmar, se le notificara al usuario su nuevo contrato para validar su
                            información y pueda ser firmado.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="CrearContrato()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles de la Solicitud</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" ref="stepper" header-nav bordered class="shadow-0" color="primary"
                        animated>
                        <q-step :name="1" title="Información General" icon="settings" :done="done1">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-list bordered>
                                    <q-expansion-item bordered group="somegroup" icon="explore" label="Detalles"
                                        default-opened header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-6 ">
                                                        <q-field color="teal" filled label="Fecha de
                                                            solicitud" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="event" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.fecha_solicitud }}
                                                                </div>
                                                            </template>
                                                        </q-field>

                                                        <!-- <q-icon name="event" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Fecha de
                                                            solicitud:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.fecha_solicitud }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-6">
                                                        <q-field color="teal" filled label="Cliente" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="person" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{ selectCotizacion.rfc_cliente + " " +
                                                                        selectCotizacion.razon_social_cliente }}
                                                                </div>
                                                            </template>
                                                        </q-field>

                                                        <!-- <q-icon name="person" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Cliente:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc_cliente + " " +
                                                                selectCotizacion.razon_social_cliente }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Vehiculo" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Marca:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.marca }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Marca" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.marca }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Modelo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.modelo }}

                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Modelo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.modelo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Versión:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.version }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Versión" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.version }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Tipo Vehiculo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.tipovehiculo }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Tipo de Vehiculo"
                                                            stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.tipovehiculo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Año:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.anio }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Año" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.anio }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Color:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.color }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Color" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.color }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Proveedor" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <q-field color="teal" filled label="RFC" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.rfc }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">RFC:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled
                                                            label="Razón Social o Nombre de la Persona" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.razon_social }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Razón Social:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.razon_social }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Domicilio:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.domicilio_fiscal }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Domicilio" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.domicilio_fiscal }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Representante:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.representante }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Representante" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.representante }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled label="Teléfono" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-phone" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.telefono }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-phone" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Teléfono:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.telefono }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled label="Correo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-at" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.correo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-at" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Correo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.correo }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles de la cotización" header-class="text-primary">
                                        <q-card>
                                            <q-card-section class="row items-center q-pb-none">
                                                <div class="text-h6">Detalles de la Cotización</div>
                                                <q-space></q-space>
                                                <q-btn flat round icon="mdi-file-document" color="primary"
                                                    @click="verCotizacion()"></q-btn>
                                            </q-card-section>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Precio:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.precio }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Precio" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.precio) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Anticipo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.anticipo }}
                                                        </div>
                                                        <q-separator /> -->

                                                        <q-field color="teal" filled label="Anticipo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.anticipo) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Seguro:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.seguro }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Seguro" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.seguro) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Enplacamiento:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.placas }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Placas" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.placas) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-calendar" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Plazos:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.plazo }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Plazos" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-calendar" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.plazo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Valor Residual:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.valorres }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Valor Residual" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.valorresidual)
                                                                    }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                </q-list>
                            </q-card>
                        </q-step>

                        <q-step :name="2" title="Cuenta Por Cobrar" icon="create_new_folder" :done="done2">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-card-section class="row items-center  q-pb-none justify-between">
                                    <div class="text-h6">Cuenta Por Cobrar</div>
                                    <q-btn icon="mdi-file-document" flat round color="primary"
                                        @click="generaPdfOrdenPago(cuentaCobrar)" />
                                </q-card-section>
                                <q-separator class="q-my-md" />
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md">
                                    <div class="col-12 col-md-6">
                                        <q-input v-model="fechaCuenta" readonly dense outlined label="Fecha"
                                            class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input class="q-ma-none q-pa-none" dense outlined
                                            v-model="cuentaCobrar.fechamafacturacion" label="Fecha de Facturación"
                                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                                            <template v-slot:after>
                                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                        transition-show="scale" transition-hide="scale">
                                                        <q-date class="q-ma-none q-pa-none"
                                                            v-model="cuentaCobrar.fechamafacturacion">
                                                            <div
                                                                class="q-ma-none q-pa-none row items-center justify-end">
                                                                <q-btn class="q-ma-none q-pa-none" v-close-popup
                                                                    label="Ok" color="primary" flat />
                                                            </div>
                                                        </q-date>
                                                    </q-popup-proxy>
                                                </q-icon>
                                            </template>
                                        </q-input>
                                        <!-- <q-input v-model="cuentaCobrar.fechamafacturacion"  dense outlined label="Fecha"
                                            class="full-width" /> -->
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <q-input v-model="cuentaCobrar.nombre" readonly dense outlined label="Nombre"
                                            class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <q-input v-model="cuentaCobrar.concepto" dense outlined label="Concepto"
                                            class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-chip v-if="estatusC == 'XC'" color="deep-orange" text-color="white"
                                            icon="mdi-clock-alert-outline">
                                            Pago pendiente
                                        </q-chip>
                                        <q-chip v-if="estatusC == 'V'" color="deep-purple" text-color="white"
                                            icon="mdi-file-clock">
                                            Valiando Pago
                                        </q-chip>
                                        <q-chip v-if="estatusC == 'P'" color="green" text-color="white"
                                            icon="mdi-check-bold">
                                            Pagado
                                        </q-chip>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-field input-class="text-right" dense outlined stack-label
                                            label="Pago Inicial" class="full-width">
                                            <template v-slot:control>
                                                <div class="self-center full-width no-outline" tabindex="0"> {{
                                                    formatoMonedaMexicana(cuentaCobrar.monto) }}</div>
                                            </template>
                                        </q-field>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <q-step :name="3" title="Factura" icon="create_new_folder" :done="done3">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-card-section class="row items-center q-pb-none justify-between">
                                    <div class="text-h6">Factura</div>

                                    <q-btn icon="mdi-whatsapp" flat round color="green"
                                        @click="notificarFactura(file)" />
                                </q-card-section>
                                <q-separator class="q-my-md" />

                            </q-card>
                        </q-step>

                        <q-step v-if="estatusC == 'P'" :name="4" title="Contrato" icon="create_new_folder"
                            :done="done4">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-card-section class="row items-center q-pb-none ">
                                    <div class="text-h6">Contrato</div>
                                    <q-space></q-space>
                                    <q-btn v-if="selectCotizacion.estatus != 'ContratoVigente'" label="Nuevo Vehiculo"
                                        icon="mdi-plus" outline color="primary" @click="NuevoCarro()" />

                                    <q-btn class="q-ml-md" v-if="selectCotizacion.estatus != 'ContratoVigente'"
                                        label="Nuevo Seguro" icon="mdi-shield-car" outline color="primary"
                                        @click="NuevoSeguro()" />

                                    <q-btn class="q-ml-md" v-if="selectCotizacion.estatus != 'ContratoVigente'"
                                        label="Nuevo Localizador" icon="mdi-car-connected" outline color="primary"
                                        @click="NuevoLocalizador()" />

                                    <q-btn v-if="selectCotizacion.estatus == 'ContratoVigente'" icon="mdi-whatsapp" flat
                                        round color="green" @click="notificarContrato()" />
                                </q-card-section>
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md"
                                    v-if="selectCotizacion.estatus != 'ContratoVigente'">
                                    <div class="col-12 col-md-12">
                                        <q-select outlined v-model="autoContrato" :options="listaCarros"
                                            label="Automovil" option-label="placa" dense required emit-value
                                            map-options>
                                            <template v-slot:option="scope">
                                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                    <q-item-section avatar>
                                                        <q-icon name="mdi-car" color="priamry" />
                                                    </q-item-section>
                                                    <q-item-section>
                                                        <q-item-label
                                                            v-html="'Permiso: ' + scope.opt.permiso + ', Placa: ' + scope.opt.placa + ', ' + scope.opt.estadoplaca + ', ' + scope.opt.numeroserie" />
                                                        <q-item-label caption>{{ scope.opt.marca + ', ' +
                                                            scope.opt.modelo + ', ' + scope.opt.tipovehiculo + ', ' +
                                                            scope.opt.anio + ', ' + scope.opt.color
                                                        }}</q-item-label>
                                                    </q-item-section>
                                                </q-item>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.marca" readonly outlined label="Marca" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.modelo" readonly outlined label="Modelo" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.tipovehiculo" readonly outlined
                                            label="Tipo de Vehiculo" dense required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.anio" readonly outlined label="Año" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.color" readonly outlined label="Color" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.numeroserie" readonly outlined
                                            label="Número de Serie" dense required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.numeromotor" readonly outlined
                                            label="Número de Motor" dense required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.permiso" readonly outlined label="Número Permiso"
                                            dense required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.placa" readonly outlined label="Placa" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <q-input v-model="autoContrato.estadoplaca" readonly outlined
                                            label="Estado (Origen)" dense required />
                                    </div>
                                </q-card-section>
                                <q-separator class="q-my-md" />
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md"
                                    v-if="selectCotizacion.estatus != 'ContratoVigente'">
                                    <div class="col-12 col-md-6">
                                        <q-input v-model="nregistro" outlined label="Num. Registro" dense required />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input class="q-ma-none q-pa-none" dense outlined v-model="fechaPago"
                                            label="Fecha maxima corte de Pago" mask="date" bottom-slots
                                            placeholder="yyyy/MM/dd">
                                            <template v-slot:after>
                                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                        transition-show="scale" transition-hide="scale">
                                                        <q-date class="q-ma-none q-pa-none" v-model="fechaPago">
                                                            <div
                                                                class="q-ma-none q-pa-none row items-center justify-end">
                                                                <q-btn class="q-ma-none q-pa-none" v-close-popup
                                                                    label="Ok" color="primary" flat />
                                                            </div>
                                                        </q-date>
                                                    </q-popup-proxy>
                                                </q-icon>
                                            </template>
                                        </q-input>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input v-model="representante" outlined label="Apoderada Legal" dense
                                            required />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input readonly v-model="puesto" outlined label="Puesto/Cargo" dense
                                            required />
                                    </div>
                                </q-card-section>
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md"
                                    v-if="selectCotizacion.estatus == 'ContratoVigente'">
                                    <VisualizadorPDFContrato></VisualizadorPDFContrato>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <!-- BOTONES DE ACCIONES -->
                        <template v-slot:navigation>
                            <q-stepper-navigation class="row" v-if="validaEstatusC != true">
                                <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                                <q-space />
                                <q-btn flat class="q-ml-sm" color="primary" label="Generar cuenta por cobrar"
                                    @click="dialogConfirmacion = true" />
                            </q-stepper-navigation>
                            <q-stepper-navigation class="row"
                                v-if="estatusC == 'P' && selectCotizacion.estatus != 'ContratoVigente'">
                                <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                                <q-space />
                                <q-btn flat class="q-ml-sm" color="primary" label="Formalizar Contrato"
                                    @click="confirmarContrato()" />
                            </q-stepper-navigation>
                        </template>
                    </q-stepper>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-12">
                <q-table dense title="Cotizaciones" class="shadow-1" :data="cotizaciones" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetCotizaciones()"
                            no-caps class="q-my-sm" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="rfc_cliente" :props="props" @click="verItem(props.row)">{{ props.row.rfc_cliente
                            }}</q-td>
                            <q-td key="razon_social_cliente" :props="props" @click="verItem(props.row)">{{
                                props.row.razon_social_cliente }}</q-td>
                            <q-td key="vehiculo" :props="props" @click="verItem(props.row)">{{
                                props.row.marca + ' ' + props.row.modelo + ' ' + props.row.version
                                }}</q-td>
                            <q-td key="proveedor" :props="props" @click="verItem(props.row)">{{
                                props.row.rfc + ' - ' + props.row.razon_social
                            }}</q-td>
                            <q-td key="precio" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.precio)
                                }}</q-td>
                            <q-td key="plazo" :props="props" @click="verItem(props.row)">{{
                                props.row.plazo
                                }}</q-td>
                            <q-td key="anticipo" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.anticipo)
                                }}</q-td>
                            <q-td key="fecha_solicitud" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_solicitud
                                }}</q-td>
                            <q-td key="estatus" :props="props">
                                <q-badge v-if="props.row.estatus == 'Aceptada'" color="green" label="NuevaCotización" />
                                <q-badge v-if="props.row.estatus == 'EnProceso'" color="purple"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'PendienteDeContrato'" color="blue"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'ContratoVigente'" color="black"
                                    :label="props.row.estatus" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";
import VisualizadorPDFContrato from "../../PDF/VisualizadorContrato.vue";
import { generarOrdenPagoPDF } from '../../PDF/OrdenPago.js' // Ajusta esta ruta

import moment from 'moment';
export default {
    components: {
        VisualizadorPDF, VisualizadorPDFContrato
    },
    data() {
        return {
            loading: false,
            cotizaciones: [],
            columns: [
                { name: 'rfc_cliente', label: 'rfc', field: 'rfc_cliente', align: 'center', sortable: true },
                { name: 'razon_social_cliente', label: 'Cliente', field: 'razon_social_cliente', align: 'center', sortable: true },
                { name: 'vehiculo', label: 'Vehiculo', field: 'vehiculo', align: 'center', sortable: true },
                { name: 'proveedor', label: 'Proveedor', field: 'proveedor', align: 'center', sortable: true },
                { name: 'precio', label: 'Precio', field: 'precio', align: 'center', sortable: true },
                { name: 'anticipo', label: 'Anticipo', field: 'anio', align: 'center', sortable: true },
                { name: 'fecha_solicitud', label: 'Fecha de Solicitud', field: 'fecha_solicitud', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogDetalles: false,
            selectCotizacion: null,
            step: 1,
            done1: false,
            done2: false,
            done3: false,
            done4: false,
            documentosUsuario: [],
            dialogVisualizador: false,

            cuentaCobrar: {
                nombre: '',
                monto: '',
                concepto: '',
                tipo: 'Adelanto',
                id_documento: '',
                id_cliente: '',
                procedencia: 'Cotización',
                fechamafacturacion: '',
                estado: 'XC'
            },
            fechaCuenta: new Date().toLocaleString('es-MX'),
            dialogConfirmacion: false,

            validaEstatusC: false,
            estatusC: '',

            dialogConfirmarContrato: false,
            listaCarros: [],
            auto: '',
            fechaPago: '',
            nregistro: '',
            representante: '',
            puesto: 'APODERADA LEGAL',

            dialogVisualizadorOP: false,

            dialogNuevoAuto: false,
            auto: {
                _id: '',
                id_ModeloAnio: '',
                numeroserie: '',
                numeromotor: '',
                placa: '',
                permiso: '',
                estadoplaca: '',
                id_proveedor: '',
                fechaadquisicion: '',
                beneficionproveedor: '',
                agencia: '',
            },
            autoContrato: {
                _id: '',
                id_ModeloAnio: '',
                numeroserie: '',
                numeromotor: '',
                placa: '',
                permiso: '',
                estadoplaca: '',
                id_proveedor: '',
                fechaadquisicion: '',
                beneficionproveedor: '',
                agencia: '',
            },
            selectModelo: '',
            selectAgencia: null,
            listaAgencias: [],

            dialogNuevoSeguro: false,

            clientes: [],
            selectCliente: null,
            selectAuto: null,
            autosCliente: [],
            listaAgenciasSeguro: [],
            selectAgenciaSeguro: null,

            fechaemision: '',
            finicio: '',
            fvencimiento: '',
            flimitepago: '',
            flimitecobro: '',
            notas: '',
            poliza: '',
            costototal: 0,
            pagoinicial: 0,
            pagoperiodo: 0,
            formapago: 'Anual',
            formacobro: 'Anual',
            endoso: '',
            tipo: '',
            agentedemisiones: '',
            numerotelsiniestro: '',
            oficinaregional: '',

            selectAutoLocalizador: null,
            dialogNuevoLocalizador: false,

            numero_serie_l: '',
            marca_l: '',
            modelo_l: '',
            tipo_l: '',
            fecha_compra_l: '',
            costo_adquisicion_l: 0,
            costo_mensual_l: 0,
            fecha_instalacion_l: '',
            estatus_l: '',

            selectAutoLocalizador: null,
            listaAgenciasLocalizador: [],
            selectAgenciaLocalizador: null,


            archivoSeleccionado: null,

        }
    },
    mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
        itemsModelos() {
            return this.$store.state.auth.listModelosStore
        }
    },
    created() {
        this.GetCotizaciones();
    },
    methods: {
        confirmarContrato() {
            this.dialogConfirmarContrato = true
        },
        async GetAutos() {
            try {
                let respuesa = await axios.get('Autos/GetAutosSinArrendarAsync/')
                console.log(respuesa.data)
                this.listaCarros = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetCotizaciones() {
            this.loading = true
            try {
                let respuesa = await axios.get('Catalogos/GetCotizacionesAceptadas/')
                console.log(respuesa.data)
                this.cotizaciones = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async verItem(item) {
            this.selectCotizacion = item
            this.cuentaCobrar.id_documento = item._id;
            this.cuentaCobrar.id_cliente = item._id_cliente;
            this.cuentaCobrar.nombre = item.rfc_cliente + " " + item.razon_social_cliente;
            this.cuentaCobrar.monto = item.pagoinicialtotal;
            this.cuentaCobrar.fechamafacturacion = ''

            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            await this.GetCxCXidDOc();
            if (this.selectCotizacion.estatus == 'ContratoVigente') {
                await this.GetContratoXIdCotizacion()
            }
            await this.GetAutos();
            this.$q.loading.hide()
            this.dialogDetalles = true
        },

        verCotizacion() {
            this.$store.state.auth.storeBase64Cotizacion = this.selectCotizacion.cotizacion_arrendafit
            this.dialogVisualizador = true
        },

        descargarPDF() {
            const fileName = this.selectCotizacion.nombre_archivo_arrendafit;
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },

        async PostCxC() {
            if (this.cuentaCobrar.fechamafacturacion == '') {
                this.$q.notify({ type: 'info', position: 'top-right', message: `Para crear la cuenta por cobrar primero debera ingresar la fecha de facturación.` });
                return
            }

            if (this.cuentaCobrar.concepto == '') {
                this.$q.notify({ type: 'info', position: 'top-right', message: `Para crear la cuenta por cobrar primero debera ingresar el concepto de la cuenta.` });
                return
            }
            console.log(this.cuentaCobrar)
            try {
                let monto = parseFloat(this.cuentaCobrar.monto)
                this.cuentaCobrar.monto = monto
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Creando cuenta por cobrar. Espere...', messageColor: 'white' })
                let respuesa = await axios.post('CXC/PostCxC/', this.cuentaCobrar)
                console.log(respuesa)

                this.selectCotizacion.estatus = 'EnProceso'
                const index = this.cotizaciones.findIndex(p => p._id === this.selectCotizacion._id)
                this.$set(this.cotizaciones, index, { ...this.selectCotizacion })
                this.dialogConfirmacion = false
                this.dialogDetalles = false

                if (respuesa.data.edopet == '1') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `La cuenta por cobrar se ha facturado correctamente.` });
                }
                if (respuesa.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error de Facturación: ' + respuesa.data.mensaje });
                }

                this.$q.loading.hide()
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear la cuenta por cobrar.` });
                console.log(error)
            }
        },

        async GetCxCXidDOc() {
            try {
                let respuesta = await axios.get('CXC/GetCxCXidDOc/' + this.selectCotizacion._id)
                console.log(respuesta.data)

                if (respuesta.data.edopet == '-1') {
                    this.cuentaCobrar = {
                        nombre: this.selectCotizacion.rfc_cliente + " " + this.selectCotizacion.razon_social_cliente,
                        monto: this.selectCotizacion.pagoinicialtotal,
                        concepto: '',
                        tipo: 'Adelanto',
                        id_documento: this.selectCotizacion._id,
                        id_cliente: this.selectCotizacion._id_cliente,
                        procedencia: 'Cotización',
                        fechamafacturacion: '',
                        estado: 'XC'
                    }

                } else {
                    let cuenta = respuesta.data.lista[0]
                    this.cuentaCobrar.fechamafacturacion = cuenta.fechamafacturacion
                    this.cuentaCobrar.fechamaximapago = cuenta.fechamaximapago
                    this.cuentaCobrar.concepto = cuenta.concepto
                    this.fechaCuenta = this.formatearFecha(cuenta.fechacreacion)
                    this.cuentaCobrar.nombre = cuenta.nombre
                    this.cuentaCobrar.monto = this.formatoMonedaMexicana(cuenta.monto)
                    this.cuentaCobrar.procedencia = 'Cotización'
                    this.cuentaCobrar.tipo = 'Adelanto'
                    this.cuentaCobrar.estado = cuenta.estado
                    this.validaEstatusC = true
                    this.estatusC = cuenta.estado
                }
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetContratoXIdCotizacion() {
            try {
                let respuesa = await axios.get('Contratos/GetContratoXidCotizacion/' + this.selectCotizacion._id)
                this.$store.state.auth.objetoContrato = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async CrearContrato() {

            if (this.autoContrato._id == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique un Auto.` });
                return
            }

            if (this.nregistro == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el Núm. de registro de contrato.` });
                return
            }

            if (this.fechaPago == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique la fecha maxima de corte del Pago.` });
                return
            }


            let validaAuto = await this.GetValidaAuto()
            let validaCliente = await this.GetValidaCliente()

            if (validaAuto == false) {
                return
            }

            if (validaCliente == false) {
                return
            }
            try {
                let objeto = {
                    id_cotizacion: this.selectCotizacion._id,
                    id_auto: this.autoContrato._id,
                    nregistro: this.nregistro,
                    fechapago: this.fechaPago,
                    representante: this.representante,
                    puesto: this.puesto
                }
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Creando contrato. Espere...', messageColor: 'white' })
                let respuesa = await axios.post('Contratos/CrearContrato/', objeto)
                console.log(respuesa)

                this.dialogConfirmarContrato = false
                this.dialogDetalles = false

                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio el contrato al cliente.` });
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el contrato.` });
                console.log(error)
            }
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

        async generaPdfOrdenPago(item) {
            let datosBancarios = await this.obtenerDatosBancareos()
            console.log(item)
            const datos = {
                folio: '0',
                fechaMaxPago: item.fechamaximapago,
                proveedor: datosBancarios.razonSocial,
                rfc: datosBancarios.rfc,
                metodoPago: 'Transferencia',
                conceptos: [
                    { cantidad: 1, descripcion: item.concepto, precioUnitario: item.monto }
                ],
                banco: datosBancarios.banco,
                cuenta: datosBancarios.numeroCuenta,
                clabe: datosBancarios.clabe,
                beneficiario: datosBancarios.nombreTitular,
                sitioWeb: datosBancarios.clabe,
                email: datosBancarios.email,
                telefono: datosBancarios.telefono,
                pais: datosBancarios.pais,
                estado: datosBancarios.estado,
                municipio: datosBancarios.municipio,
                colonia: datosBancarios.colonia,
                calle: datosBancarios.calle,
                numeroExterior: datosBancarios.numeroExterior,
                numeroInterior: datosBancarios.numeroInterior,
                cp: datosBancarios.cp,
                estatus: item.estado
            }
            try {
                const logoURL = require('../../../assets/logo_top.png')
                let logoBase64 = await this.cargarImagenComoBase64(logoURL);
                let base64 = ''
                base64 = await generarOrdenPagoPDF(datos, logoBase64);
                this.$store.state.auth.storeBase64Cotizacion = 'data:application/pdf;base64,' + base64.split(',')[1];
                this.dialogVisualizadorOP = true
            } catch (error) {
                console.log(error)
            }
        },

        descargarPDFOP() {
            const fileName = 'OrdenPago.pdf';
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },


        async notificarCuentaCobrar() {
            console.log(this.selectCotizacion)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Enviando notificación por WhatsApp. Espere...', messageColor: 'white' })
            let objeto = {
                id_usuario: this.selectCotizacion._id_cliente,
                mensaje: 'Se envia el documento de Pago',
                base64: this.$store.state.auth.storeBase64Cotizacion.split(",")[1]
            }
            try {
                let response = await axios.post('Notificaciones/Notificacion', objeto);
                console.log(response)
                if (response.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se envio la notificación.` });
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar la notificación.` });
                }
                this.$q.loading.hide()
            } catch (error) {
                console.log(error)
            }
        },

        notificarFactura() {

        },

        async notificarContrato() {
            let contrato = this.$store.state.auth.objetoContrato
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Enviando notificación por WhatsApp. Espere...', messageColor: 'white' })
            let objeto = {
                id_usuario: this.selectCotizacion._id_cliente,
                mensaje: 'Se envia el contrato de ' + this.selectCotizacion.rfc + ' ' + this.selectCotizacion.razon_social + ' con Folio ' + contrato.nregistro + ' correspondinte al auto ' + contrato.marca + ' ' + contrato.modelo + ' con placas ' + contrato.placa,
                base64: this.$store.state.auth.storeBase64Contrato.split(",")[1]
            }
            try {
                let response = await axios.post('Notificaciones/Notificacion', objeto);
                console.log(response)
                if (response.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se envio la notificación.` });
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar la notificación.` });
                }
                this.$q.loading.hide()
            } catch (error) {
                console.log(error)
            }
        },
        async obtenerDatosBancareos() {
            try {
                const res = await axios.get('Configuracion/GetEmpresa')
                console.log(res)
                return res.data
            } catch (err) {
                console.error(err)
            }
        },

        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
        NuevoCarro() {

            this.GetModelos()
            this.GetProveedoresAgencia()
            this.auto = {
                id_ModeloAnio: '',
                numeroserie: '',
                numeromotor: '',
                placa: '',
                estadoplaca: '',
                id_proveedor: '',
                fechaadquisicion: '',
                beneficionproveedor: '',
                agencia: '',
                permiso: '',
            }

            this.selectModelo = ''

            this.dialogNuevoAuto = true
        },

        async PostAuto() {

            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el nombre de la agencia.` });
                return
            }
            if (this.selectModelo == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el modelo del vehiculo a dar de alta.` });
                return
            }


            this.auto.id_proveedor = this.selectAgencia._id
            this.auto.agencia = this.selectAgencia.rfc + ' | ' + this.selectAgencia.razon_social
            this.auto.id_ModeloAnio = this.selectModelo._id
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando Auto. Espere...', messageColor: 'white' })
            try {
                const resp = await axios.post(`Autos/AltaAuto/`, this.auto);
                console.log(resp)
                this.$q.loading.hide()

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Auto registrado correctamente.` });
                    this.dialogNuevoAuto = false
                    this.GetAutos()
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al guardar el Auto. Intentelo de nuevo...` });
                }

            } catch (err) {
                console.log(err)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al guardar el Auto. Intentelo de nuevo...` });
            }
        },


        async GetModelos() {
            try {
                let respuesa = await axios.get('Autos/GetListaModelosxMarca/Todos')
                console.log(respuesa)
                this.$store.state.auth.listModelosStore = respuesa.data

            } catch (error) {
                console.log(error)
            }
        },

        async GetProveedoresAgencia() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Agencia')
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetProveedoresLocalizador() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Localizador')
                console.log(respuesa.data)
                this.listaAgenciasLocalizador = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        NuevoSeguro() {
            console.log(this.selectCotizacion)

            if (this.autoContrato._id == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto al que se le asignara el seguro.` });
                return
            }



            this.selectAgenciaSeguro = null;
            this.fechaemision = ''
            this.finicio = ''
            this.fvencimiento = ''
            this.flimitepago = ''
            this.flimitecobro = ''
            this.notas = ''
            this.poliza = ''
            this.costototal = this.selectCotizacion.seguro
            this.pagoinicial = 0
            this.pagoperiodo = 0
            this.formapago = 'Anual'
            this.formacobro = 'Anual'
            this.endoso = ''
            this.tipo = ''
            this.agentedemisiones = ''
            this.numerotelsiniestro = ''
            this.oficinaregional = ''
            this.GetProveedores()
            this.dialogNuevoSeguro = true
        },

        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Seguro')
                console.log(respuesa.data)
                this.listaAgenciasSeguro = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async PostSeguro() {

            if (this.selectAgenciaSeguro == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el Proveedor de su Seguro.` });
                return
            }

            const archivo = this.archivoSeleccionado;
            if (!archivo) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Debe cargar el Documero PDF de la poliza.',
                    position: 'top-right'
                });
                return;
            }

            const base64 = await this.convertirABase64(archivo);
            let nombre_archivo = archivo.name;
            let archivo64base = base64;
            let objeto = {
                id_auto: this.autoContrato._id,
                id_cliente: this.selectCotizacion._id_cliente,

                nombrecliente: this.selectCotizacion.rfc_cliente + ' ' + this.selectCotizacion.razon_social_cliente,
                fechaemision: this.fechaemision,
                finicio: this.finicio,
                fvencimiento: this.fvencimiento,
                flimitepago: this.flimitepago,
                flimitecobro: this.flimitecobro,
                notas: this.notas,
                poliza: this.poliza,
                id_proveedor: this.selectAgenciaSeguro._id,
                compania: this.selectAgenciaSeguro.razon_social,
                costototal: this.costototal,
                pagoinicial: this.pagoinicial,
                pagoperiodo: this.pagoperiodo,
                formapago: 'Anual',
                formacobro: 'Anual',
                tipo: this.tipo,
                endoso: this.endoso,
                agentedemisiones: this.agentedemisiones,
                numerotelsiniestro: this.numerotelsiniestro,
                oficinaregional: this.oficinaregional,
                polizaPdf: {
                    poliza: archivo64base,
                    ruta: '',
                    nombre: nombre_archivo,
                    b64com: '',
                }
            }

            try {
                console.log(objeto)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Asignando seguro. Espere...', messageColor: 'white' })

                const resp = await axios.post(`Autos/AltaSeguroInicial/`, objeto);
                console.log(resp)

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se asigno correctamento el seguro al vehiculo.` });
                    this.dialogNuevoSeguro = false
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                }
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                console.log(error)
            }
        },

        async GetValidaAuto() {
            try {
                const res = await axios.get(`Autos/GetValidaAuto/${this.autoContrato._id}`);
                console.log(res)
                return true;
            } catch (err) {
                console.log(err);
                this.$q.notify({ type: 'negative', position: 'top-right', message: err.response.data });
                return false;
            }
        },

        async GetValidaCliente() {
            try {
                const res = await axios.get(`Configuracion/GetValidaCliente/${this.selectCotizacion._id_cliente}`);
                console.log(res)
                return true;
            } catch (err) {
                console.log(err);
                this.$q.notify({ type: 'negative', position: 'top-right', message: err.response.data });
                return false;
            }
        },


        NuevoLocalizador() {

            if (this.autoContrato._id == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto al que se le asignara el localizador.` });
                return
            }

            this.selectAgenciaLocalizador = null;

            this.numero_serie_l = '';
            this.marca_l = '';
            this.modelo_l = '';
            this.tipo_l = '';
            this.fecha_compra_l = '';
            this.costo_adquisicion_l = 0;
            this.costo_mensual_l = 0;
            this.fecha_instalacion_l = '';
            this.estatus_l = '';
            this.GetProveedoresLocalizador()
            this.dialogNuevoLocalizador = true;
        },

        async PostLocalizador() {
            if (this.selectAgenciaLocalizador == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el Proveedor de su localizador.` });
                return
            }

            let objeto = {
                _id: '',
                _id_vehiculo: this.autoContrato._id,
                _id_proveedor: this.selectAgenciaLocalizador._id,
                proveedor: this.selectAgenciaLocalizador.razon_social,
                _id_cliente: this.selectCotizacion._id_cliente,
                numero_serie: this.numero_serie_l,
                marca: this.marca_l,
                modelo: this.modelo_l,
                tipo: this.tipo_l,
                fecha_compra: this.fecha_compra_l,
                fecha_instalacion: this.fecha_instalacion_l,
                estatus: 'Activo',
                costo_adquisicion: this.costo_adquisicion_l,
                costo_mensual: this.costo_mensual_l,
            }
            try {
                console.log(objeto)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Asignando localizador. Espere...', messageColor: 'white' })
                const resp = await axios.post(`Autos/PostLocalizador/`, objeto);
                console.log(resp)
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se asigno correctamento el localizador al vehiculo.` });
                this.$q.loading.hide()
                this.dialogNuevoLocalizador = false

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al asignar el localizador. Intentelo de nuevo...` });
                console.log(error)
            }
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>